import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
// import Welcome from './pages/Welcome';
import Login from './pages/Login';
// import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import LeadsPage from './pages/LeadsPage';
// import AssignmentsPage from './pages/AssignmentsPage';
import IntegrationPage from './pages/IntegrationPage';
import Error from './pages/Error';

// Component to handle authenticated user redirects
const AuthRedirect = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // If user is logged in and trying to access public pages, redirect to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/"
        element={<Navigate to="/login" replace />}
      />
      {/* <Route
        path="/welcome"
        element={
          <AuthRedirect>
            <Welcome />
          </AuthRedirect>
        }
      /> */}
      <Route
        path="/login"
        element={
          <AuthRedirect>
            <Login />
          </AuthRedirect>
        }
      />
      {/* <Route
        path="/register"
        element={
          <AuthRedirect>
            <Register />
          </AuthRedirect>
        }
      /> */}

      {/* Protected Dashboard Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      >
        {/* Nested routes */}
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="leads" element={<LeadsPage />} />
        {/* <Route path="assignments" element={<AssignmentsPage />} /> */}
        <Route path="integrations" element={<IntegrationPage />} />
      </Route>

      {/* Catch all redirect */}
      <Route path="*" element={<Error />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
